import { render } from "./BusDetails.vue?vue&type=template&id=38fdda3a&scoped=true"
import script from "./BusDetails.vue?vue&type=script&lang=js"
export * from "./BusDetails.vue?vue&type=script&lang=js"

import "./BusDetails.vue?vue&type=style&index=0&id=38fdda3a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fdda3a"]])

export default __exports__